export default __webpack_public_path__ + "facebook.svg";